import { render, staticRenderFns } from "./CommissionRecord.vue?vue&type=template&id=be0d447e"
import script from "./CommissionRecord.vue?vue&type=script&lang=js"
export * from "./CommissionRecord.vue?vue&type=script&lang=js"
import style0 from "./CommissionRecord.vue?vue&type=style&index=0&id=be0d447e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports